(function ($) {
    "use strict";


    var $doc = $(document);


    $doc.on('wpcf7:submit', function (event, detail) {
        if (!detail || !detail.apiResponse) {
            // Invalid API
            return true;
        }

        if (detail.apiResponse.status != 'liqpay_pending') {
            // Ignore all but our custom status
            return true;
        }

        if (!detail.apiResponse.liqpay) {
            // LiqPay response missing
            return true;
        }

        var liqpay = detail.apiResponse.liqpay;

        if (!liqpay.data || !liqpay.signature) {
            // Required LiqPay payment data missing
            return true;
        }

        var $container = $('#liqpay-wpcf7'),
            $modal     = $container.closest('.modal'),
            $wpcf7     = $('#' + detail.id),
            $form      = $wpcf7.find('.wpcf7-form'),
            $message   = $form.find('.wpcf7-response-output');

        // $container.closest('.modal-preloader').addClass('loading');

        $container.html('').liqpay(liqpay).one('liqpay.ready', function () {
            // $(this).closest('.modal-preloader').removeClass('loading');
        }).one('liqpay.callback', function (event, response) {
            if (response && response.status) {
                if (response.status === 'success' || response.status === 'sandbox'
                 || response.status === 'subscribed' || response.status === 'unsubscribed') {
                    $form.removeClass('custom-liqpay-pending').addClass('sent');
                    $message.removeClass('wpcf7-custom-liqpay-pending').addClass('wpcf7-mail-sent-ok');
                }
            }
        });

        $modal.modal('show');
    });
})(window.jQuery);
